import type { ReactNode } from "react";
import React from "react";
import { Tooltip as MuiTooltip } from "@mui/material";
import SvgHelp from "@/assets/svgs/help.svg";
import classNames from "classnames";
import type { Position } from "@/components/shared/data-display/tooltip/tooltip";
import styles from "./icon-tooltip.module.scss";

export interface IconTooltipProps {
  /**
   * What is displayed by the tooltip. Could be a string, HTML, or any existing component.
   */
  content: ReactNode;
  /**
   * The placement of the tooltip content relative to the element being hovered.
   * If there is no room in that orientation, the tooltip automatically shifts to
   * a different placement.
   */
  position?: Position;
  /**
   * If `arrow = true`, the tooltip will have an arrow indicating which element it refers to.
   */
  arrow?: boolean | undefined;
}

export const IconTooltip = (iProps: IconTooltipProps) => {
  const { content, position = "right", arrow } = iProps;

  return (
    <MuiTooltip title={content} placement={position} arrow={arrow}>
      <span role="tooltip" className={classNames(styles.iconWrapper)}>
        <SvgHelp />
      </span>
    </MuiTooltip>
  );
};
